<template>
  <v-container fluid full-height grid-list-md>
    <v-layout row wrap>
      <v-flex xs6>
        <div class="text-xs-left">
          <v-breadcrumbs :items="breadcrumbs" divider=">"></v-breadcrumbs>
        </div>
      </v-flex>
      <v-flex xs6>
        <div style="display: flex; justify-content: flex-end">
          <v-menu offset-y>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                color="success"
                :loading="buttonLoading"
                v-bind="attrs"
                v-on="on"
              >
                <v-icon>cloud_download</v-icon>Export
              </v-btn>
            </template>

            <v-list>
              <v-list-tile @click="reprintReport('printReport')">
                <v-list-tile-content>
                  <v-list-tile-title>PRINT ALL</v-list-tile-title>
                </v-list-tile-content>
              </v-list-tile>
            </v-list>
          </v-menu>
          <v-btn @click="showFilters = !showFilters" color="#FF4545">
            <v-icon>filter_list</v-icon>Filter
            <v-icon>{{
              showFilters ? "arrow_drop_up" : "arrow_drop_down"
            }}</v-icon>
          </v-btn>
        </div>
      </v-flex>
      <v-flex xs12 v-if="showFilters">
        <v-card>
          <v-layout row wrap class="pa-3">
            <v-flex sm3>
              <v-menu
                :nudge-right="40"
                lazy
                transition="scale-transition"
                offset-y
                full-width
                min-width="290px"
              >
                <v-text-field
                  slot="activator"
                  v-model="queryParams.fromDate"
                  label="From Date"
                  prepend-icon="event"
                  readonly
                ></v-text-field>
                <v-date-picker v-model="queryParams.fromDate"></v-date-picker>
              </v-menu>
            </v-flex>
            <v-flex sm3>
              <v-menu
                :nudge-right="40"
                lazy
                transition="scale-transition"
                offset-y
                full-width
                min-width="290px"
              >
                <v-text-field
                  slot="activator"
                  v-model="queryParams.toDate"
                  label="To Date"
                  prepend-icon="event"
                  readonly
                ></v-text-field>
                <v-date-picker v-model="queryParams.toDate"></v-date-picker>
              </v-menu>
            </v-flex>
            <v-flex sm3>
              <v-select
                :items="shopList"
                label="Select Shop"
                v-model="queryParams.shopId"
                item-text="name"
                item-value="id"
                :readonly="user.role.roleName == 'BRANCH_ADMIN'"
                @change="changeShop($event)"
              ></v-select>
            </v-flex>
            <v-flex sm3>
              <v-autocomplete
                v-model="queryParams.customerIds"
                :items="selectedCustomerList"
                label="Customer"
                @click="showCustomers()"
                item-text="code"
                item-value="id"
                multiple
                menu-props="auto"
                autocomplete
              ></v-autocomplete>
            </v-flex>
            <v-flex sm3>
              <v-text-field
                name="issueNo"
                label="Issue No"
                v-model="queryParams.issueNo"
                type="text"
              ></v-text-field>
            </v-flex>
            <v-flex sm3>
              <v-text-field
                name="categoryGroup"
                label="Category Group"
                v-model="categoryGroupName"
                type="text"
                @click="showCategoryGroup()"
              ></v-text-field>
            </v-flex>
            <v-flex sm3>
              <v-btn outline color="primary" @click="onSearch">
                Search
                <v-icon right>search</v-icon>
              </v-btn>
            </v-flex>
          </v-layout>
        </v-card>
      </v-flex>
      <v-flex xs12 class="mt-1">
        <v-card>
          <v-data-table
            :headers="headers"
            :items="customerProductSaleReportDetailList"
            class="elevation-1"
            :loading="showListLoading"
            :total-items="totalRows"
            :rows-per-page-items="rowsPerPageItems"
            :pagination.sync="pagination"
            :must-sort="true"
          >
            <template slot="items" slot-scope="props">
              <td>
                {{ props.item.issueDateInMilliSecond | format-ms-date }}
              </td>
              <td>{{ props.item.issueNo }}</td>
              <td>{{ props.item.customerName }}</td>
              <td>{{ props.item.categoryGroupName }}</td>
              <td>{{ props.item.productName }}</td>
              <td>{{ props.item.qty | decFormat(6) }}</td>
              <td>{{ props.item.unitName }}</td>
              <td style="text-align: right">
                {{ props.item.price | decFormat(6) }}
              </td>
              <td style="text-align: right">
                {{ props.item.discount | decFormat(6) }}
              </td>
              <td style="text-align: right">
                {{ props.item.itemNetAmount | decFormat(6) }}
              </td>
              <td style="text-align: right">
                {{ props.item.payment }}
              </td>
            </template>
          </v-data-table>
        </v-card>
      </v-flex>
    </v-layout>
    <!-- print report -->
    <div
      id="printReport"
      style="border: 1px solid black; width: 300px"
      v-show="false"
    >
      <div style="text-align: center">
        <p style="font-size: 15px; margin: 1px">{{ shopName || "All Shop" }}</p>
      </div>
      <div style="text-align: center">
        <p style="font-size: 15px; margin: 1px">
          Customer Product Sale Report By Category Group
        </p>
      </div>
      <div style="text-align: center">
        <p style="font-size: 15px; margin: 1px">
          From: [{{ queryParams.fromDate }}] To: [{{ queryParams.toDate }}]
        </p>
      </div>
      <br />
      <div style="padding-left: 5px; padding-right: 5px">
        <table
          style="
            font-family: arial, sans-serif;
            border-collapse: collapse;
            width: 100%;
            font-size: 12px;
            border-top: 1px solid black;
          "
        >
          <thead
            style="border-bottom: 1px solid black; border-top: 1px solid black"
          >
            <tr>
              <th style="border: 1px solid black; text-align: center">
                Issue Date
              </th>
              <th style="border: 1px solid black; text-align: center">
                Issue No
              </th>
              <th style="border: 1px solid black; text-align: center">
                Customer Name
              </th>
              <th style="border: 1px solid black; text-align: center">
                Category Group Name
              </th>
              <th style="border: 1px solid black; text-align: center">
                Product Name
              </th>
              <th style="border: 1px solid black; text-align: center">
                Quantity
              </th>
              <th style="border: 1px solid black; text-align: center">Unit</th>
              <th style="border: 1px solid black; text-align: center">Price</th>
              <th style="border: 1px solid black; text-align: center">
                Discount
              </th>
              <th style="border: 1px solid black; text-align: center">
                Net Amount
              </th>
              <th style="border: 1px solid black; text-align: center">
                Payment
              </th>
            </tr>
          </thead>
          <tbody
            v-for="(
              customerProductSaleReport, index
            ) in allCustomerProductSaleReportList"
            :key="index"
          >
            <tr
              v-for="(
                item, i
              ) in customerProductSaleReport.customerProductSaleReportDetailList"
              :key="i"
            >
              <td
                v-if="i == 0"
                :rowspan="
                  customerProductSaleReport.customerProductSaleReportDetailList
                    .length
                "
                style="
                  border: 1px solid black;
                  text-align: left;
                  vertical-align: text-top;
                "
              >
                {{
                  customerProductSaleReport.issueDateInMilliSeconds
                    | format-ms-date
                }}
              </td>
              <td
                v-if="i == 0"
                :rowspan="
                  customerProductSaleReport.customerProductSaleReportDetailList
                    .length
                "
                style="
                  border: 1px solid black;
                  text-align: left;
                  vertical-align: text-top;
                "
              >
                {{ customerProductSaleReport.issueNo }}
              </td>
              <td
                v-if="i == 0"
                :rowspan="
                  customerProductSaleReport.customerProductSaleReportDetailList
                    .length
                "
                style="
                  border: 1px solid black;
                  text-align: left;
                  vertical-align: text-top;
                "
              >
                {{ customerProductSaleReport.customerName }}
              </td>
              <td
                v-if="i == 0"
                :rowspan="
                  customerProductSaleReport.customerProductSaleReportDetailList
                    .length
                "
                style="
                  border: 1px solid black;
                  text-align: left;
                  vertical-align: text-top;
                "
              >
                {{ customerProductSaleReport.categoryGroupName }}
              </td>
              <td style="border: 1px solid black; text-align: left">
                {{ item.productName }}
              </td>
              <td style="border: 1px solid black; text-align: right">
                {{ item.qty | decFormat(6) }}
              </td>
              <td style="border: 1px solid black; text-align: left">
                {{ item.unitName }}
              </td>
              <td style="border: 1px solid black; text-align: right">
                {{ item.price | decFormat(6) }}
              </td>
              <td style="border: 1px solid black; text-align: right">
                {{ (item.discount * item.qty) | decFormat(6) }}
              </td>
              <td style="border: 1px solid black; text-align: right">
                {{ item.itemNetAmount | decFormat(6) }}
              </td>
              <td style="border: 1px solid black; text-align: right">
                {{ customerProductSaleReport.payment }}
              </td>
            </tr>

            <tr>
              <td
                style="
                  border: 1px solid black;
                  font-weight: bold;
                  text-align: right;
                "
                colspan="9"
              >
                Sub Total
              </td>
              <td
                style="
                  border: 1px solid black;
                  font-weight: bold;
                  text-align: right;
                "
              >
                {{ customerProductSaleReport.subTotalNetAmount | decFormat(6) }}
              </td>
              <td
                style="
                  border: 1px solid black;
                  font-weight: bold;
                  text-align: right;
                "
              ></td>
            </tr>
          </tbody>
          <tr>
            <td
              style="
                border: 1px solid black;
                font-weight: bold;
                text-align: right;
              "
              colspan="9"
            >
              Grand Total
            </td>
            <td
              style="
                border: 1px solid black;
                font-weight: bold;
                text-align: right;
              "
            >
              {{ grandTotal | decFormat(6) }}
            </td>
            <td
              style="
                border: 1px solid black;
                font-weight: bold;
                text-align: right;
              "
            ></td>
          </tr>
        </table>
      </div>
    </div>

    <!-- customer dialog -->
    <v-dialog v-model="showCustomerListDialog" scrollable max-width="1000px">
      <v-card>
        <v-card-title>
          <!-- Search Section -->
          <v-layout wrap>
            <v-flex xs12 sm6 md3>
              <v-text-field
                name="name"
                label="Customer Name"
                type="text"
                class="mr-1"
                v-model="customerQueryParams.name"
              ></v-text-field>
            </v-flex>
            <v-flex xs12 sm6 md3>
              <v-text-field
                name="code"
                label="Customer Code"
                type="text"
                class="mr-1"
                v-model="customerQueryParams.code"
              ></v-text-field>
            </v-flex>
            <v-flex xs12 sm6 md3>
              <v-text-field
                name="email"
                label="Customer Email"
                type="text"
                class="mr-1"
                v-model="customerQueryParams.email"
              ></v-text-field>
            </v-flex>
            <v-flex sm2>
              <v-btn outline color="primary" @click="onSearchCustomer">
                Search
                <v-icon right>search</v-icon>
              </v-btn>
            </v-flex>
          </v-layout>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text>
          <!-- Customer List Section -->
          <v-flex xs12 class="mt-1">
            <v-data-table
              v-model="selectedCustomerList"
              :headers="customerHeader"
              :items="activeCustomerList"
              select-all
              class="elevation-1"
              :loading="showListLoading"
              :total-items="customertotalRows"
              :rows-per-page-items="rowsPerPageItems"
              :pagination.sync="customerpagination"
              :must-sort="true"
            >
              <template slot="headers" slot-scope="props">
                <tr>
                  <th>
                    <v-checkbox
                      primary
                      hide-details
                      @click.native="toggleAll"
                      :input-value="props.all"
                      :indeterminate="props.indeterminate"
                    ></v-checkbox>
                  </th>
                  <th v-for="header in props.headers" :key="header.text">
                    {{ header.text }}
                  </th>
                </tr>
              </template>
              <template slot="items" slot-scope="props">
                <td>
                  <v-checkbox
                    primary
                    hide-details
                    :input-value="props.selected"
                    :value="props.item"
                    :indeterminate="props.indeterminate"
                    v-model="selectedCustomerList"
                    multiple
                  ></v-checkbox>
                </td>
                <td>
                  <a>{{ props.item.code }}</a>
                </td>
                <td>{{ props.item.name }}</td>
                <td>{{ props.item.email }}</td>
                <td>{{ props.item.phoneNo }}</td>
                <td>{{ props.item.creditLevel.name }}</td>
              </template>
            </v-data-table>
            <div class="text-xs-right">
              <v-btn color="primary" @click="setCustomer">Ok</v-btn>
            </div>
          </v-flex>
        </v-card-text>
      </v-card>
    </v-dialog>

    <!-- category group dialog -->
    <v-dialog
      v-model="showCategoryGroupListDialog"
      scrollable
      max-width="1000px"
    >
      <v-card>
        <v-card-title>
          <!-- Search Section -->
          <v-layout wrap>
            <v-flex xs12 sm6 md3>
              <v-text-field
                name="name"
                label="Category Group Name"
                type="text"
                class="mr-1"
                v-model="categoryGroupParams.name"
              ></v-text-field>
            </v-flex>
            <v-flex xs12 sm6 md3>
              <v-text-field
                name="code"
                label="Category Group Code"
                type="text"
                class="mr-1"
                v-model="categoryGroupParams.code"
              ></v-text-field>
            </v-flex>
            <v-flex xs12 sm6 md3>
              <v-text-field
                name="status"
                label="Status"
                type="text"
                class="mr-1"
                v-model="categoryGroupParams.status"
              ></v-text-field>
            </v-flex>
            <v-flex sm2>
              <v-btn outline color="primary" @click="onSearchCategoryGroup">
                Search
                <v-icon right>search</v-icon>
              </v-btn>
            </v-flex>
          </v-layout>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text>
          <!-- List Section -->
          <v-flex xs12 class="mt-1">
            <v-data-table
              :headers="categoryGroupHeader"
              :items="categoryGroupList"
              class="elevation-1"
              :loading="showListLoading"
              :total-items="categoryGroupTotalRows"
              :rows-per-page-items="rowsPerPageItems"
              :pagination.sync="categoryGroupPagination"
              :must-sort="true"
            >
              <template slot="items" slot-scope="props">
                <td>
                  <a @click="setCategoryGroup(props.item)">{{
                    props.item.code
                  }}</a>
                </td>
                <td>{{ props.item.name }}</td>
                <td>{{ props.item.status }}</td>
                <td>{{ props.item.updatedBy }}</td>
                <td>
                  {{
                    props.item.updatedDateInMilliSeconds | format-ms-date
                  }}
                </td>
              </template>
            </v-data-table>
          </v-flex>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import { commonService } from "../../services/common-service";
import { shopService } from "../../services/shop-service";
import { customerService } from "../../services/customer-service";
import { categoryGroupService } from "../../services/category-group-service";
import { customerProductSaleReportService } from "../../services/customer-product-sale-report-service";

export default {
  name: "CustomerProductSaleReportByCategoryGroup",
  data: () => ({
    user: JSON.parse(localStorage.getItem("user")),
    showFilters: false,
    breadcrumbs: [
      {
        text: "Reports",
        disabled: true,
      },
      {
        text: "Sale Reports",
        disabled: true,
      },
      {
        text: "Customer Product Sale Report By Category Group",
        disabled: true,
      },
    ],
    valid: true,
    queryParams: {
      fromDate: commonService.formatDate(new Date(), "YYYY-MM-DD"),
      toDate: commonService.formatDate(new Date(), "YYYY-MM-DD"),
      shopId: "",
      customerIds: [],
      issueNo: "",
      wholeSaleStatus: "FINISHED",
      categoryGroupId: "",
    },
    shopList: [],
    selectedCustomerList: [],
    customerQueryParams: {
      name: "",
      code: "",
      email: "",
    },
    showListLoading: false,
    customerpagination: {
      descending: true,
      page: 1,
      rowsPerPage: 10,
      sortBy: "name",
      totalItems: 0,
    },
    activeCustomerList: [],
    customertotalRows: 0,
    showCustomerListDialog: false,
    customerHeader: [
      { text: "Code", align: "left", value: "code" },
      { text: "Name", align: "left", value: "name" },
      { text: "Email", value: "email" },
      { text: "PhoneNo", value: "phoneNo" },
      { text: "Credit Level", value: "creditLevel", sortable: false },
    ],
    rowsPerPageItems: [25, 50, 100],
    categoryGroupParams: {
      name: "",
      code: "",
      status: "",
    },
    categoryGroupPagination: {
      descending: true,
      page: 1,
      rowsPerPage: 10,
      sortBy: "name",
      totalItems: 0,
    },
    categoryGroupList: [],
    categoryGroupTotalRows: 0,
    showCategoryGroupListDialog: false,
    categoryGroupHeader: [
      { text: "Code", align: "left", value: "code" },
      { text: "Name", align: "left", value: "name" },
      { text: "Status", value: "status", sortable: false },
      { text: "Updated By", value: "updatedBy", sortable: false },
      { text: "Updated Date", value: "updatedDate" },
    ],
    categoryGroupName: "",
    pagination: {
      descending: false,
      page: 1,
      rowsPerPage: 50,
      sortBy: "null",
      totalItems: 0,
    },
    clonequeryParams: new Object(),
    customerProductSaleReportDetailList: [],
    totalRows: 0,
    headers: [
      { text: "Issue Date", value: "issue_date" },
      { text: "Issue No", value: "issueNo", sortable: false },
      { text: "Customer", value: "customerName", sortable: false },
      { text: "Category Group", value: "categoryGroupName", sortable: false },
      { text: "Product Name", value: "productName", sortable: false },
      { text: "Qty", value: "qty", sortable: false },
      { text: "Unit", value: "unit", sortable: false },
      { text: "Price", value: "price", sortable: false },
      { text: "Discount", value: "discount", sortable: false },
      { text: "Net Amount", value: "netAmount", sortable: false },
      { text: "Pay Type", value: "payType", sortable: false },
    ],
    decimalFormat: "",
    buttonLoading: false,
    allCustomerProductSaleReportList: [],
    grandTotal: "",
    shopName: "",
  }),
  watch: {
    pagination: {
      handler() {
        this.getCustomerProductSaleReportByCategory();
      },
      deep: true,
    },
    customerpagination: {
      handler() {
        this.getActiveCustomer();
      },
      deep: true,
    },
    categoryGroupPagination: {
      handler() {
        this.getCategoryGroup();
      },
      deep: true,
    },
  },
  created() {
    if (this.user.role.roleName == "BRANCH_ADMIN") {
      this.queryParams.shopId = this.user.shopId;
    }
    //for deep linking
    if (this.$route.query.fromDate) {
      this.queryParams.fromDate = this.$route.query.fromDate;
    }
    if (this.$route.query.toDate) {
      this.queryParams.toDate = this.$route.query.toDate;
    }
    if (this.$route.query.shopId) {
      this.queryParams.shopId = this.$route.query.shopId;
    }
    if (this.$route.query.page) {
      this.pagination.page = this.$route.query.page;
    }
    if (this.$route.query.size) {
      this.pagination.size = this.$route.query.size;
    }
    this.getShopList();
    this.decimalFormat = commonService.formatdecimal();
    this.onSearch();
  },
  methods: {
    getShopList() {
      shopService
        .getAllShop()
        .then((res) => {
          this.shopList = res.data;
        })
        .catch((err) => {
          console.error(err);
        });
    },
    showCustomers() {
      // Clean query params
      this.customerQueryParams.code = "";
      this.customerQueryParams.name = "";
      this.customerQueryParams.email = "";
      this.selectedCustomerList = [];
      this.queryParams.customerIds = [];

      this.getActiveCustomer().then(
        (this.showCustomerListDialog = !this.showCustomerListDialog)
      );
    },
    getActiveCustomer() {
      this.showListLoading = true;
      let order = this.customerpagination.descending ? "desc" : "asc";
      return customerService
        .getCustomers(
          this.customerQueryParams,
          this.customerpagination.page,
          this.customerpagination.rowsPerPage,
          this.customerpagination.sortBy + "," + order
        )
        .then((res) => {
          if (res.data) {
            this.activeCustomerList = res.data.customerList;
            this.customertotalRows = res.data.totalElements;
          }
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => {
          this.showListLoading = false;
        });
    },
    onSearchCustomer() {
      this.customerQueryParams.page = this.customerpagination.page;
      this.customerQueryParams.size = this.customerpagination.rowsPerPage;
      this.getActiveCustomer();
    },
    toggleAll() {
      if (this.selectedCustomerList.length) {
        this.selectedCustomerList = [];
      } else {
        this.selectedCustomerList = this.activeCustomerList.slice();
      }
    },
    setCustomer() {
      if (this.selectedCustomerList.length) {
        this.queryParams.customerIds = [];
        this.selectedCustomerList.forEach((element) => {
          if (!this.queryParams.customerIds.includes(element.id))
            this.queryParams.customerIds.push(element.id);
        });
      }
      this.showCustomerListDialog = !this.showCustomerListDialog;
    },
    showCategoryGroup() {
      // Clean query params
      this.categoryGroupParams.code = "";
      this.categoryGroupParams.name = "";
      this.categoryGroupParams.status = "";
      this.queryParams.categoryGroupId = "";
      this.categoryGroupName = "";

      this.getCategoryGroup().then(
        (this.showCategoryGroupListDialog = !this.showCategoryGroupListDialog)
      );
    },
    getCategoryGroup() {
      this.showListLoading = true;
      let order = this.categoryGroupPagination.descending ? "desc" : "asc";
      return categoryGroupService
        .getCategoryGroupList(
          this.categoryGroupParams,
          this.categoryGroupPagination.page,
          this.categoryGroupPagination.rowsPerPage,
          this.categoryGroupPagination.sortBy + "," + order
        )
        .then((res) => {
          if (res.data) {
            this.categoryGroupList = res.data.categoryGroupList;
            this.categoryGroupTotalRows = res.data.totalElements;
          }
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => {
          this.showListLoading = false;
        });
    },
    onSearchCategoryGroup() {
      this.categoryGroupParams.page = this.categoryGroupPagination.page;
      this.categoryGroupParams.size = this.categoryGroupPagination.rowsPerPage;
      this.getCategoryGroup();
    },
    setCategoryGroup(categoryGroup) {
      this.queryParams.categoryGroupId = categoryGroup.id;
      this.categoryGroupName = categoryGroup.name;
      this.showCategoryGroupListDialog = !this.showCategoryGroupListDialog;
    },
    onSearch() {
      this.queryParams.page = this.pagination.page;
      this.queryParams.size = this.pagination.rowsPerPage;
      this.$router.replace({
        name: "customer-product-sale-report-by-category-group",
        query: this.queryParams,
      });
      this.getCustomerProductSaleReportByCategory();
      this.clonequeryParams = JSON.parse(JSON.stringify(this.queryParams));
    },
    getCustomerProductSaleReportByCategory() {
      this.showListLoading = true;
      let order = this.pagination.descending ? "desc" : "asc";
      customerProductSaleReportService
        .getCustomerProductSaleReportByCategoryGroup(
          this.queryParams,
          this.pagination.page,
          this.pagination.rowsPerPage,
          this.pagination.sortBy + "," + order
        )
        .then((res) => {
          if (res.data) {
            this.customerProductSaleReportDetailList =
              res.data.customerProductSaleReportDetailList;
            this.totalRows = res.data.totalElements;
          }
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => {
          this.showListLoading = false;
        });
    },
    reprintReport(divName) {
      this.buttonLoading = true;
      customerProductSaleReportService
        .getCustomerProductSaleReportByCategoryGroupPrint(this.clonequeryParams)
        .then((res) => {
          this.allCustomerProductSaleReportList =
            res.data.customerProductdSaleReportList;
          this.grandTotal = res.data.grandTotal;
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => {
          var printContents = document.getElementById(divName).innerHTML;
          var reprintWindow = window.open(
            "",
            "MsgWindow",
            "width=500,height=500"
          );
          reprintWindow.document.write(printContents);
          setTimeout(() => {
            reprintWindow.print();
            reprintWindow.close();
          }, 600);
          this.buttonLoading = false;
        });
    },
    changeShop(item) {
      this.shopName = this.shopList.filter((shop) => shop.id == item)[0].name;
    },
  },
};
</script>